// English translations of the Italian back-office strings (keys = Italian source text; see lib/i18n.ts).
const dict: Record<string, string> = {
  "— nessuna (categoria principale) —": "— none (top-level category) —",
  "— seleziona —": "— select —",
  "… e altre {n} righe.": "… and {n} more rows.",
  "({n} non in questa vista)": "({n} not in this view)",
  "(es. stesse candele in fragranze diverse)": "(e.g. the same candles in different fragrances)",
  "(fino a 4, sotto il prezzo)": "(up to 4, below the price)",
  "(modificato)": "(edited)",
  "(si apre in una nuova scheda)": "(opens in a new tab)",
  "{amount} di sconto": "{amount} off",
  "{day}: {amount} · {n} ordini": "{day}: {amount} · {n} orders",
  "{kg} kg · serve per calcolare la spedizione": "{kg} kg · used to calculate shipping",
  "{n} aggiornati": "{n} updated",
  "{n} clienti registrati": "{n} registered customers",
  "{n} da preparare": "{n} to prepare",
  "{n} errori": "{n} errors",
  "{n} foto": "{n} photos",
  "{n} giacenza modificata, non ancora salvate": "{n} stock level changed, not yet saved",
  "{n} giacenze aggiornate.": "{n} stock levels updated.",
  "{n} giacenze incluse": "{n} stock levels included",
  "{n} giacenze modificate, non ancora salvate": "{n} stock levels changed, not yet saved",
  "{n} giorni": "{n} days",
  "{n} nuovi": "{n} new",
  "{n} operazioni registrate": "{n} actions logged",
  "{n} ordini": "{n} orders",
  "{n} ordini da preparare": "{n} orders to prepare",
  "{n} pezzi": "{n} pieces",
  "{n} prodotti": "{n} products",
  "{n} punti di forza": "{n} highlights",
  "{n} punto di forza": "{n} highlight",
  "{n} pz": "{n} pcs",
  "{n} righe con errori (saranno ignorate)": "{n} rows with errors (will be skipped)",
  "{n} righe valide": "{n} valid rows",
  "{n} selezionati": "{n} selected",
  "{n} su 5": "{n} of 5",
  "{n} utilizzi": "{n} uses",
  "{n}/200 caratteri": "{n}/200 characters",
  "{n}% di sconto": "{n}% off",
  "{name} è ora membro del Club.": "{name} is now a Club member.",
  "{name} non è più membro del Club.": "{name} is no longer a Club member.",
  "{name}: preparato": "{name}: picked",
  "{p}% dei clienti registrati": "{p}% of registered customers",
  "+ Invita persona": "+ Invite person",
  "+ Nuova categoria": "+ New category",
  "+ Nuova regola": "+ New rule",
  "+ Nuovo codice": "+ New code",
  "+ Nuovo negozio": "+ New store",
  "+ Nuovo punto": "+ New point",
  "1. Verifica (nessuna modifica)": "1. Check (no changes)",
  "2. Importa": "2. Import",
  "Accedi": "Sign in",
  "Accessi alla gestione online": "Online management access",
  "Accesso attivo": "Access enabled",
  "Accesso non autorizzato": "Unauthorised access",
  "Aggiorna": "Refresh",
  "Aggiorna dati": "Refresh data",
  "Aggiornamento automatico ogni 30 secondi": "Auto-refreshes every 30 seconds",
  "Aggiornamento…": "Refreshing…",
  "Aggiungi al Club": "Add to Club",
  "Aggiungi nota": "Add note",
  "Aggiungi punto di forza": "Add highlight",
  "Al": "To",
  "Al giorno": "To date",
  "al netto dei rimborsi": "net of refunds",
  "Alcuni negozi non hanno ancora indirizzo e orari: completali prima del lancio.": "Some stores don't have an address and opening hours yet: complete them before launch.",
  "aliquota IVA non valida (0, 4, 5, 10, 22)": "invalid VAT rate (0, 4, 5, 10, 22)",
  "Almeno 10 caratteri": "At least 10 characters",
  "Altre azioni per {n}": "More actions for {n}",
  "Altre impostazioni": "Other settings",
  "Altro": "More",
  "Amministratore": "Administrator",
  "Amministratore — tutto, inclusi negozi e personale": "Administrator — everything, including stores and staff",
  "Analisi dati": "Analytics",
  "Ancora nessuna operazione registrata.": "No actions logged yet.",
  "Andamento {metric}: periodo attuale {current}, periodo precedente {previous}": "{metric} trend: current period {current}, previous period {previous}",
  "Andamento vendite": "Sales trend",
  "Annulla": "Cancel",
  "Annulla e rimborsa": "Cancel and refund",
  "Annulla e rimborsa {amount}": "Cancel and refund {amount}",
  "Annulla l'ordine {number}": "Cancel order {number}",
  "Annulla modifiche": "Discard changes",
  "Annulla ordine": "Cancel order",
  "Annulla ordine…": "Cancel order…",
  "Annullati": "Cancelled",
  "Annullato": "Cancelled",
  "Anteprima": "Preview",
  "Applica": "Apply",
  "Apri menu": "Open menu",
  "Apri ordine": "Open order",
  "Area riservata al personale.": "Staff-only area.",
  "Attiva": "Activate",
  "Attivo": "Active",
  "Avviso scorte": "Stock alert",
  "Azione": "Action",
  "Azioni": "Actions",
  "Azzera filtri": "Clear filters",
  "Buon pomeriggio": "Good afternoon",
  "Buonasera": "Good evening",
  "Buongiorno": "Good morning",
  "C.F.": "Tax code",
  "Cambia foto": "Change photo",
  "Cambia password": "Change password",
  "Cambio di stato non consentito.": "Status change not allowed.",
  "Canali di vendita": "Sales channels",
  "Carica foto": "Upload photo",
  "Carica immagini": "Upload images",
  "Caricamento…": "Loading…",
  "Casa (per ogni ambiente)": "House (for every room)",
  "CASA & TE Club: iscrizione gratuita, offerte riservate ai membri.": "CASA & TE Club: free to join, members-only offers.",
  "Catalogo": "Catalogue",
  "Categoria": "Category",
  "Categoria padre": "Parent category",
  "Categoria superiore": "Parent category",
  "Categorie": "Categories",
  "Causale": "Reason",
  "Cerca": "Search",
  "Cerca nome, marca, SKU, EAN": "Search name, brand, SKU, EAN",
  "Cerca nome, SKU, EAN (anche con lettore barcode)": "Search name, SKU, EAN (barcode scanner works too)",
  "Cerca ordini": "Search orders",
  "Cerca ordini, prodotti, clienti…": "Search orders, products, customers…",
  "Cerca ordini, prodotti…": "Search orders, products…",
  "Cerca prodotto": "Search product",
  "Chi ha modificato cosa, e quando.": "Who changed what, and when.",
  "Chiudi menu": "Close menu",
  "Chiudi messaggio": "Close message",
  "Chiudi senza salvare": "Close without saving",
  "Ci sono {n} ordini": "There are {n} orders",
  "Ci sono modifiche non salvate. Uscire senza salvare?": "You have unsaved changes. Leave without saving?",
  "Città": "City",
  "Cliente": "Customer",
  "Cliente (Club)": "Customer (Club)",
  "Clienti": "Customers",
  "Clienti degli ultimi 7 giorni": "Customers in the last 7 days",
  "Clienti di oggi": "Today's customers",
  "Codice": "Code",
  "Codice (es. LU1)": "Code (e.g. LU1)",
  "Codice a barre": "Barcode",
  "Codice di tracciamento": "Tracking number",
  "Codice già esistente.": "Code already exists.",
  "Codice sconto": "Discount code",
  "Codice, nome e città sono obbligatori.": "Code, name and city are required.",
  "Codice: 3–32 caratteri tra lettere, numeri, - e _.": "Code: 3–32 characters (letters, numbers, - and _).",
  "Codici sconto": "Discount codes",
  "Colore": "Colour",
  "Colore / materiale": "Colour / material",
  "colore e varianti: massimo 40 caratteri": "colour and variants: 40 characters max",
  "Compila i campi con * e crea il prodotto.": "Fill in the fields marked * and create the product.",
  "Compila il foglio {sheet} del modello (le istruzioni sono nel foglio {help}) e caricalo qui così com'è, in formato .xlsx.": "Fill in the {sheet} sheet of the template (instructions are in the {help} sheet) and upload it here as is, in .xlsx format.",
  "Compila nome, indirizzo, città, CAP (5 cifre) e provincia (2 lettere).": "Enter name, address, city, postcode (5 digits) and province (2 letters).",
  "Completati": "Completed",
  "Completato": "Completed",
  "Con la spunta «Mostra in home» scegli le 8 categorie principali mostrate nella home del negozio.": "Tick «Show on home» to choose the 8 main categories shown on the shop home page.",
  "Conferma password": "Confirm password",
  "Conferma rimozione": "Confirm removal",
  "Conferma spedizione": "Confirm shipment",
  "confezione non valida (es. 500 ml, 1,5 l, 250 g, 6 pz)": "invalid pack size (e.g. 500 ml, 1,5 l, 250 g, 6 pz)",
  "Configurazione mancante": "Missing configuration",
  "Consegna": "Delivery",
  "Consegna a domicilio": "Home delivery",
  "Consegnato al cliente": "Delivered to customer",
  "Consegnato al cliente (ritirato)": "Delivered to customer (collected)",
  "Contenuto confezione": "Pack contents",
  "Copia apps/admin/.env.example in apps/admin/.env con URL e chiave anon di Supabase.": "Copy apps/admin/.env.example to apps/admin/.env with the Supabase URL and anon key.",
  "Copia numero ordine": "Copy order number",
  "Copiato": "Copied",
  "Corriere": "Carrier",
  "Crea o aggiorna prodotti, prezzi, schede e giacenze in blocco da Excel o CSV (chiave: SKU)": "Create or update products, prices, listings and stock in bulk from Excel or CSV (key: SKU)",
  "Crea prodotto": "Create product",
  "Creato": "Created",
  "Credenziali non valide.": "Invalid credentials.",
  "Cronologia": "History",
  "Cuore (preferito)": "Heart (favourite)",
  "da {n} giorni": "{n} days ago",
  "da {n} giorno": "{n} day ago",
  "da {n} h": "{n} h ago",
  "da {n} min": "{n} min ago",
  "Da completare": "To complete",
  "Da pagare": "Unpaid",
  "Da preparare": "To prepare",
  "Dal": "From",
  "Dal giorno": "From date",
  "Data": "Date",
  "Data e ora": "Date and time",
  "Data ordine": "Order date",
  "Dati fattura": "Invoice details",
  "Descrizione": "Description",
  "Descrizione del Club": "Club description",
  "Descrizione mostrata ai clienti": "Description shown to customers",
  "Dettaglio completo": "Full details",
  "di cui {n} da iniziare": "of which {n} not started",
  "Diamante (design, qualità)": "Diamond (design, quality)",
  "Disattiva": "Deactivate",
  "Disattivato": "Deactivated",
  "Disattivo": "Inactive",
  "Disponibili": "Available",
  "Domicilio": "Home",
  "Dopo la creazione potrai aggiungere immagini e giacenze.": "After creating it you can add images and stock.",
  "EAN / codice a barre": "EAN / barcode",
  "EAN non valido": "Invalid EAN",
  "Elemento": "Item",
  "Elemento non trovato.": "Item not found.",
  "Elemento o utente": "Item or user",
  "Elenco": "List",
  "Elimina": "Delete",
  "Elimina immagine": "Delete image",
  "Eliminare definitivamente la recensione di {name}? Il cliente potrà scriverne una nuova.": "Permanently delete {name}'s review? The customer will be able to write a new one.",
  "Eliminare la categoria \"{name}\"? I prodotti resteranno senza categoria.": "Delete the category \"{name}\"? Its products will be left without a category.",
  "Eliminare questa immagine dal prodotto?": "Delete this image from the product?",
  "Eliminato": "Deleted",
  "Email": "Email",
  "Email non valida.": "Invalid email.",
  "Email, nome, telefono": "Email, name, phone",
  "emessi su Stripe": "issued via Stripe",
  "English": "English",
  "Errore": "Error",
  "es. Beige": "e.g. Beige",
  "es. BRT, GLS, Poste": "e.g. BRT, GLS, Poste",
  "es. diffusore-tessuto": "e.g. diffusore-tessuto",
  "es. Fatto in Italia": "e.g. Fatto in Italia",
  "es. fragranza": "e.g. fragranza",
  "es. InPost, BRT Fermopoint": "e.g. InPost, BRT Fermopoint",
  "es. prodotto mancante": "e.g. item missing",
  "es. Tessuto": "e.g. Tessuto",
  "Esaurito": "Out of stock",
  "Esci": "Sign out",
  "Esegui prima la verifica: l'importazione si abilita quando non ci sono errori.": "Run the check first: import is enabled once there are no errors.",
  "Esporta consensi marketing": "Export marketing consents",
  "Esporta CSV": "Export CSV",
  "Esporta membri (CSV)": "Export members (CSV)",
  "Esportazione…": "Exporting…",
  "Etichetta": "Label",
  "Fattura richiesta": "Invoice requested",
  "Fatturato": "Revenue",
  "Filtra per stato": "Filter by status",
  "Filtro": "Filter",
  "Fine": "End",
  "fino al {date}": "until {date}",
  "Foglia (naturale)": "Leaf (natural)",
  "Formati accettati: JPG, PNG, WEBP.": "Accepted formats: JPG, PNG, WEBP.",
  "Foto di copertina (cerchio in home)": "Cover photo (home circle)",
  "generato dal nome": "generated from the name",
  "Gestione categorie": "Categories",
  "Gestione inventario": "Inventory",
  "Gestione negozi": "Stores",
  "Gestione ordini": "Orders",
  "Gestione prodotti": "Products",
  "Gestione staff": "Staff",
  "Gestisci in Marketing": "Manage in Marketing",
  "Giacenza {name}": "Stock {name}",
  "Giacenza {store}": "Stock {store}",
  "giacenza {store} non valida": "invalid stock for {store}",
  "Giacenza non valida: usa un numero intero da 0 in su.": "Invalid stock: use a whole number from 0 up.",
  "Giacenze": "Stock",
  "Giacenze per negozio": "Stock by store",
  "Giacenze vendibili online per negozio. Gli ordini online le scalano automaticamente.": "Stock available for online sale, by store. Online orders deduct it automatically.",
  "Goccia (liquidi, fragranze)": "Drop (liquids, fragrances)",
  "Gruppo varianti": "Variant group",
  "Hai {n} modifica non salvata. Vuoi scartarle?": "You have {n} unsaved change. Discard it?",
  "Hai {n} modifiche non salvate. Vuoi scartarle?": "You have {n} unsaved changes. Discard them?",
  "Home": "Home",
  "I nuovi ordini pagati compaiono qui da soli. Puoi lasciare questa pagina aperta.": "New paid orders appear here automatically. You can leave this page open.",
  "Icona {n}": "Icon {n}",
  "Ieri": "Yesterday",
  "ieri {value}": "yesterday {value}",
  "il cliente": "the customer",
  "Il cliente vedrà: {label} · {pack}": "The customer will see: {label} · {pack}",
  "Il Club al momento non accetta nuove iscrizioni.": "The Club is not accepting new members at the moment.",
  "Il mio account": "My account",
  "Il peso in grammi è obbligatorio (serve per la spedizione).": "Weight in grams is required (used for shipping).",
  "Il prezzo barrato deve essere maggiore del prezzo.": "The compare-at price must be higher than the price.",
  "Il rimborso viene inviato subito tramite Stripe e non si può annullare.": "The refund is sent immediately via Stripe and cannot be undone.",
  "Il tuo account non è abilitato alla gestione. Contatta un amministratore.": "Your account doesn't have back-office access. Contact an administrator.",
  "Immagine troppo grande (max 5 MB).": "Image too large (max 5 MB).",
  "Immagini": "Images",
  "Import CSV": "CSV import",
  "Importa da Excel": "Import from Excel",
  "Importa prodotti": "Import products",
  "Importazione {i}/{n}…": "Importing {i}/{n}…",
  "Importazione completata": "Import complete",
  "Importi rapidi": "Quick amounts",
  "Importo": "Amount",
  "Importo (€)": "Amount (€)",
  "Importo da rimborsare (residuo {amount})": "Amount to refund ({amount} remaining)",
  "Importo del rimborso non valido.": "Invalid refund amount.",
  "Importo fisso": "Fixed amount",
  "Importo non valido.": "Invalid amount.",
  "Impossibile leggere il file Excel. Salvalo come .xlsx oppure come CSV e riprova.": "Couldn't read the Excel file. Save it as .xlsx or as CSV and try again.",
  "Imposta la password": "Set password",
  "Impostazioni": "Settings",
  "Impostazioni del Club": "Club settings",
  "Impostazioni del Club salvate.": "Club settings saved.",
  "Impostazioni del negozio": "Store settings",
  "Impostazioni di sistema": "System settings",
  "In attesa di pagamento": "Awaiting payment",
  "In evidenza": "Featured",
  "In evidenza nella home": "Featured on home",
  "In home": "On home",
  "In preparazione": "Being prepared",
  "Incassi, consegne e prodotti più venduti nel periodo scelto.": "Revenue, deliveries and best-selling products for the selected period.",
  "Incasso netto": "Net revenue",
  "Incasso per giorno": "Revenue per day",
  "Incasso per giorno: {list}.": "Revenue per day: {list}.",
  "indica anche la categoria della sottocategoria": "also specify the subcategory's parent category",
  "Indica il nome della variante (es. \"Tessuto\") per questo prodotto.": "Enter the variant name (e.g. \"Tessuto\") for this product.",
  "indica il nome della variante (es. Tessuto)": "enter the variant name (e.g. Tessuto)",
  "Indirizzi e orari vengono mostrati ai clienti per il ritiro": "Addresses and opening hours are shown to customers for pickup",
  "Indirizzi, orari e ritiro in negozio": "Addresses, opening hours and in-store pickup",
  "Indirizzo": "Address",
  "Indirizzo pagina (slug)": "Page address (slug)",
  "Inizia preparazione": "Start preparing",
  "Inizio": "Start",
  "Inserisci l'email.": "Enter your email.",
  "Inserisci solo punti reali concordati con il corriere. I punti \"DEMO\" del database di prova vanno disattivati prima del lancio.": "Only add real points agreed with the carrier. The \"DEMO\" points from the test database must be deactivated before launch.",
  "Inserisci un importo tra €0,01 e {max}.": "Enter an amount between €0,01 and {max}.",
  "Inserisci un numero intero tra 0 e 1000.": "Enter a whole number between 0 and 1000.",
  "Intero importo residuo": "Full remaining amount",
  "Intervallo di date non valido (al massimo un anno).": "Invalid date range (one year max).",
  "Inventario": "Inventory",
  "Invia invito": "Send invitation",
  "Invio a Stripe…": "Sending to Stripe…",
  "Invita persona": "Invite person",
  "Inviti e ruoli del personale": "Staff invitations and roles",
  "Invito inviato a {email}: riceverà un link per impostare la password.": "Invitation sent to {email}: they'll receive a link to set their password.",
  "Iscrizioni al Club": "Club sign-ups",
  "Iscrizioni aperte nel negozio online": "Sign-ups open in the online shop",
  "Iscrizioni e descrizione del Club": "Club sign-ups and description",
  "Istruzioni (testo)": "Instructions (text)",
  "Italiano": "Italiano",
  "IVA {rate}%": "VAT {rate}%",
  "JPG, PNG o WEBP fino a 5 MB. Sfondo chiaro, formato quadrato (1200 × 1200).": "JPG, PNG or WEBP up to 5 MB. Light background, square format (1200 × 1200).",
  "L'ordine verrà annullato e i prodotti tornano disponibili in magazzino.": "The order will be cancelled and the products will go back into stock.",
  "La password deve avere almeno 10 caratteri.": "Password must be at least 10 characters.",
  "Lascia vuoto per generarlo": "Leave empty to generate it",
  "Le celle vuote non cancellano i dati già presenti.": "Empty cells don't erase existing data.",
  "Le password non coincidono.": "Passwords don't match.",
  "Limite per cliente": "Limit per customer",
  "Lingua dell’interfaccia": "Interface language",
  "Lingua non disponibile.": "Language not available.",
  "Link scaduto o non valido. Richiedi un nuovo link dalla pagina di accesso.": "Link expired or invalid. Request a new link from the sign-in page.",
  "Link tracciamento (https://)": "Tracking link (https://)",
  "Lo sconto si applica ai prodotti; le fasce di spedizione usano l'importo scontato.": "The discount applies to products; shipping bands use the discounted amount.",
  "Locker e negozi convenzionati proposti al checkout": "Lockers and partner shops offered at checkout",
  "Lun–Sab 9:00–19:30": "Lun–Sab 9:00–19:30",
  "Magazzino": "Inventory",
  "Magazzino in ordine": "Inventory in order",
  "Mano (fatto a mano)": "Hand (handmade)",
  "Marca": "Brand",
  "Marketing": "Marketing",
  "massimo 10 immagini": "10 images max",
  "massimo 4 punti di forza": "4 highlights max",
  "Massimo per ordine": "Max per order",
  "Max pezzi per ordine": "Max pieces per order",
  "Membri": "Members",
  "Membri del Club": "Club members",
  "Membro dal": "Member since",
  "Membro del Club": "Club member",
  "Metodo": "Method",
  "Metti «In evidenza» nella home": "Feature on the home page",
  "Minimo": "Minimum",
  "minimo {amount}": "minimum {amount}",
  "Modalità di consegna": "Delivery method",
  "Modello CSV": "CSV template",
  "Modifica": "Edit",
  "Modifica accesso": "Edit access",
  "Modifica categoria": "Edit category",
  "Modifica codice": "Edit code",
  "Modifica manuale": "Manual adjustment",
  "Modifica negozio": "Edit store",
  "Modifica punto": "Edit point",
  "Modifica regola": "Edit rule",
  "Modificato": "Edited",
  "Modifiche": "Changes",
  "Modifiche con effetto immediato su app e sito. Le regole attuali sono quelle approvate (docs/PROJECT_CONTEXT.md §6); la fascia oltre 10 kg è provvisoria.": "Changes take effect immediately on the app and website. The current rules are the approved ones (docs/PROJECT_CONTEXT.md §6); the band above 10 kg is provisional.",
  "Modifiche non salvate": "Unsaved changes",
  "Mostra": "Show",
  "Mostra in home": "Show on home",
  "Mostra in home ({n}/8 scelte; l'ordine segue il campo \"Ordine\")": "Show on home ({n}/8 selected; order follows the \"Order\" field)",
  "Mostrato come “Varianti di …”": "Shown as “Variants of …”",
  "Motivo (visibile al cliente)": "Reason (visible to customer)",
  "Movimenti": "Movements",
  "Movimenti · {name}": "Movements · {name}",
  "N. ordine": "Order no.",
  "Nascondi": "Hide",
  "Nascosta": "Hidden",
  "Navigazione principale": "Main navigation",
  "Negozi": "Stores",
  "Negozi e spedizioni": "Stores & shipping",
  "Negozio": "Store",
  "Negozio online": "Online shop",
  "Negozio preferito": "Preferred store",
  "Nessun cliente trovato.": "No customers found.",
  "Nessun cliente.": "No customers.",
  "Nessun codice riservato al Club. Creane uno in Marketing e spunta l’opzione per i membri del Club.": "No codes reserved for the Club yet. Create one in Marketing and tick the Club members option.",
  "Nessun membro trovato.": "No members found.",
  "Nessun movimento.": "No movements.",
  "Nessun nuovo ordine.": "No new orders.",
  "Nessun ordine con questi filtri.": "No orders match these filters.",
  "Nessun ordine da preparare": "No orders to prepare",
  "Nessun ordine in attesa di ritiro o spedizione.": "No orders awaiting pickup or shipment.",
  "Nessun ordine in corso.": "No orders in progress.",
  "Nessun ordine nel periodo.": "No orders in this period.",
  "Nessun ordine.": "No orders.",
  "Nessun prodotto con {n} pezzi o meno.": "No products with {n} pieces or fewer.",
  "Nessun prodotto sotto scorta in questo negozio.": "No low-stock products in this store.",
  "Nessun prodotto trovato.": "No products found.",
  "Nessun prodotto. Importa il catalogo da CSV o crea un prodotto.": "No products. Import the catalogue from CSV or create a product.",
  "nessun rimborso": "no refunds",
  "Nessuna": "None",
  "Nessuna operazione con questi filtri.": "No actions match these filters.",
  "Nessuna recensione nascosta.": "No hidden reviews.",
  "Nessuna recensione.": "No reviews.",
  "nessuna vendita nel periodo": "no sales in this period",
  "Nessuna vendita nel periodo.": "No sales in this period.",
  "nessuno da preparare": "none to prepare",
  "No": "No",
  "Nome": "Name",
  "Nome *": "Name *",
  "Nome breve sotto la miniatura": "Short name under the thumbnail",
  "nome mancante": "missing name",
  "Nome variante": "Variant name",
  "Nome visualizzato": "Display name",
  "Non attiva": "Inactive",
  "Non hai i permessi per questa operazione.": "You don't have permission for this action.",
  "Non iscritto": "Not a member",
  "Non pagato": "Unpaid",
  "Non pubblicati": "Unpublished",
  "Non pubblicato": "Unpublished",
  "Nota": "Note",
  "Note": "Notes",
  "Note del cliente: {notes}": "Customer notes: {notes}",
  "Note interne": "Internal notes",
  "Numero ordini": "Number of orders",
  "Numero, email, nome, telefono": "Number, email, name, phone",
  "Nuova categoria": "New category",
  "Nuova password": "New password",
  "Nuova regola": "New rule",
  "Nuovi clienti": "New customers",
  "Nuovi clienti degli ultimi 7 giorni": "New customers in the last 7 days",
  "Nuovi membri (30 giorni)": "New members (30 days)",
  "Nuovo codice sconto": "New discount code",
  "Nuovo negozio": "New store",
  "Nuovo prodotto": "New product",
  "Nuovo punto di ritiro": "New pickup point",
  "Obbligatori: {columns}.": "Required: {columns}.",
  "Offerte Club attive": "Active Club offers",
  "Offerte riservate ai membri": "Members-only offers",
  "Oggi": "Today",
  "Oggi è {date} — insieme rendiamo la vita quotidiana ancora più bella.": "Today is {date} — together, let's make everyday life even more beautiful.",
  "ogni immagine deve essere un link che inizia con https://": "each image must be a link starting with https://",
  "Ogni punto di forza può avere al massimo 40 caratteri.": "Each highlight can be at most 40 characters.",
  "Orari": "Opening hours",
  "Orari (mostrati ai clienti)": "Opening hours (shown to customers)",
  "Ordine": "Order",
  "Ordine {number}": "Order {number}",
  "Ordine annullato": "Order cancelled",
  "Ordine annullato e {amount} rimborsati. I prodotti sono tornati in magazzino.": "Order cancelled and {amount} refunded. The products are back in stock.",
  "Ordine annullato. I prodotti sono tornati in magazzino.": "Order cancelled. The products are back in stock.",
  "Ordine di visualizzazione": "Display order",
  "Ordine non rimborsabile.": "Order cannot be refunded.",
  "Ordine online": "Online order",
  "Ordine selezionato": "Selected order",
  "Ordine##posizione": "Sort order",
  "Ordini": "Orders",
  "Ordini da evadere": "Orders to fulfil",
  "Ordini da evadere negli ultimi 7 giorni": "Orders to fulfil over the last 7 days",
  "Ordini da preparare": "Orders to prepare",
  "Ordini degli ultimi 7 giorni": "Orders in the last 7 days",
  "Ordini pagati": "Paid orders",
  "Ordini recenti": "Recent orders",
  "Ordini, magazzino e catalogo dei negozi di Arezzo e Lucca, in un unico posto.": "Orders, inventory and catalogue for the Arezzo and Lucca stores, all in one place.",
  "P.IVA": "VAT no.",
  "Padre": "Parent",
  "Pagamento": "Payment",
  "Pagamento non riuscito": "Payment failed",
  "Pagamento ricevuto su ordine annullato: verificare il rimborso automatico su Stripe.": "Payment received on a cancelled order: check the automatic refund in Stripe.",
  "Pagamento Stripe:": "Stripe payment:",
  "Pagamento: {status}": "Payment: {status}",
  "Pagato": "Paid",
  "pagato {age}": "paid {age}",
  "Pagina {n}": "Page {n}",
  "Panoramica": "Overview",
  "Password": "Password",
  "Password aggiornata.": "Password updated.",
  "Password dimenticata / primo accesso": "Forgot password / first sign-in",
  "Per il prezzo al litro/kg indica sia la quantità sia l’unità (oppure lascia vuoti entrambi).": "For the price per litre/kg, enter both quantity and unit (or leave both empty).",
  "Per il prezzo al litro/kg obbligatorio per legge (es. 500 ml)": "For the price per litre/kg required by law (e.g. 500 ml)",
  "per ordine pagato": "per paid order",
  "per pezzi": "by units sold",
  "Percentuale": "Percentage",
  "Percentuale (%)": "Percentage (%)",
  "Percentuale tra 1 e 100.": "Percentage between 1 and 100.",
  "Periodo": "Period",
  "Periodo attuale": "Current period",
  "Periodo precedente": "Previous period",
  "Periodo precedente ({day}): {value}": "Previous period ({day}): {value}",
  "Permessi aggiornati.": "Permissions updated.",
  "Persona": "Person",
  "Personale": "Staff",
  "Personale negozio": "Store staff",
  "Personale negozio — ordini e magazzino del proprio negozio": "Store staff — orders and inventory for their own store",
  "Personalizzato": "Custom",
  "Peso": "Weight",
  "Peso (g)": "Weight (g)",
  "Peso da (g, incluso)": "Weight from (g, inclusive)",
  "Peso fino a (g, incluso)": "Weight up to (g, inclusive)",
  "Peso in grammi *": "Weight in grams *",
  "peso mancante (necessario per il calcolo della spedizione)": "missing weight (needed to calculate shipping)",
  "Peso massimo": "Max weight",
  "Peso minimo": "Min weight",
  "Precedente": "Previous",
  "Preferenze personali e impostazioni del negozio.": "Personal preferences and store settings.",
  "Prepara ordini da spedire (domicilio / punti di ritiro)": "Prepare orders for shipping (home / pickup points)",
  "Preparati": "Picked",
  "Preparazione ordini": "Order picking",
  "Preparazione ordini per negozio": "Order picking by store",
  "Prezzi per peso e importo": "Prices by weight and amount",
  "Prezzo": "Price",
  "Prezzo (€)": "Price (€)",
  "Prezzo € (IVA inclusa) *": "Price € (incl. VAT) *",
  "Prezzo barrato": "Compare-at price",
  "Prezzo barrato €": "Compare-at price €",
  "prezzo barrato deve essere maggiore del prezzo": "compare-at price must be higher than the price",
  "Prezzo e spedizione": "Price and shipping",
  "prezzo non valido": "invalid price",
  "Prezzo non valido (usa 0 per gratuito).": "Invalid price (use 0 for free).",
  "Prezzo non valido.": "Invalid price.",
  "Prezzo più basso degli ultimi 30 giorni (Omnibus)": "Lowest price in the last 30 days (Omnibus)",
  "Principale": "Main",
  "Priorità": "Priority",
  "Problema": "Problem",
  "Prodotti": "Products",
  "Prodotti più venduti": "Best sellers",
  "Prodotti più venduti TOP 5": "Top 5 best sellers",
  "Prodotto": "Product",
  "Prodotto e {n} giacenze salvati.": "Product and {n} stock levels saved.",
  "Prodotto salvato.": "Product saved.",
  "Programma fedeltà": "Loyalty programme",
  "Pronti": "Ready",
  "Pronto": "Ready",
  "Provincia": "Province",
  "Provvisoria": "Provisional",
  "Pubblicati": "Published",
  "Pubblicato": "Published",
  "Pubblicato, visibile ai clienti": "Published, visible to customers",
  "Punti convenzionati per il ritiro": "Partner pickup points",
  "Punti di forza": "Highlights",
  "Punti di ritiro": "Pickup points",
  "punto di forza {n} non valido (max 40 caratteri; icona tra: {icons})": "invalid highlight {n} (max 40 characters; icon one of: {icons})",
  "Punto di ritiro": "Pickup point",
  "Punto ritiro": "Pickup point",
  "Q.tà": "Qty",
  "Quadrata, almeno 400×400 px. Senza foto il cerchio mostra l’icona del reparto.": "Square, at least 400×400 px. Without a photo the circle shows the department icon.",
  "Quantità": "Quantity",
  "Quantità confezione": "Pack quantity",
  "Quantità della confezione non valida.": "Invalid pack quantity.",
  "Quantità non valida.": "Invalid quantity.",
  "Questa variante *": "This variant *",
  "Questo mese": "This month",
  "Recensione": "Review",
  "Recensione di {name} di nuovo visibile.": "{name}'s review is visible again.",
  "Recensione di {name} nascosta: non conta più nella media.": "{name}'s review hidden: it no longer counts towards the average.",
  "Recensione eliminata.": "Review deleted.",
  "Recensioni": "Reviews",
  "Registra spedizione": "Record shipment",
  "Registrato": "Registered",
  "Registro attività": "Activity log",
  "Regole valutate per priorità crescente: vince la prima che corrisponde. Il ritiro in negozio è sempre gratuito.": "Rules are evaluated in ascending priority: the first match wins. In-store pickup is always free.",
  "Rendi principale": "Make main",
  "Responsabile": "Manager",
  "Responsabile — catalogo, prezzi, promozioni, rimborsi, tutti i negozi": "Manager — catalogue, prices, promotions, refunds, all stores",
  "Rete": "Network",
  "Rete / corriere": "Network / carrier",
  "Rete: {carrier}": "Network: {carrier}",
  "Riciclo (sostenibile)": "Recycle (sustainable)",
  "Rifornisci": "Restock",
  "Riga": "Row",
  "Rimborsa": "Refund",
  "Rimborsa {amount}": "Refund {amount}",
  "Rimborsa {amount} a {name}": "Refund {amount} to {name}",
  "Rimborsato": "Refunded",
  "Rimborsato parzialmente": "Partially refunded",
  "Rimborsi": "Refunds",
  "Rimborsi con un clic tramite Stripe": "One-click refunds via Stripe",
  "Rimborso di {amount} emesso. Il cliente lo vedrà in 5–10 giorni lavorativi.": "Refund of {amount} issued. The customer will see it within 5–10 working days.",
  "Rimborso parziale": "Partial refund",
  "Rimuovi": "Remove",
  "Rimuovi dal Club": "Remove from Club",
  "Rimuovi punto {n}": "Remove point {n}",
  "rispetto a ieri": "vs yesterday",
  "rispetto al giorno prima": "vs the previous day",
  "Risultato verifica": "Check result",
  "Ritiro": "Pickup",
  "Ritiro in negozio": "In-store pickup",
  "Ritiro in negozio abilitato": "In-store pickup enabled",
  "Ruolo": "Role",
  "Salva": "Save",
  "Salva giacenze": "Save stock",
  "Salva nota": "Save note",
  "Salva password": "Save password",
  "Salvataggio…": "Saving…",
  "Scarica modello Excel": "Download Excel template",
  "Scatola (confezione)": "Box (packaging)",
  "Scegli file Excel o CSV": "Choose Excel or CSV file",
  "Scegli un ordine dalla lista: il più vecchio è in cima.": "Pick an order from the list: the oldest is at the top.",
  "Scheda": "Listing",
  "Scheda nel negozio online": "Online shop listing",
  "Scintilla (pulito, brillante)": "Sparkle (clean, shiny)",
  "Sconto": "Discount",
  "Sconto {code}": "Discount {code}",
  "Scontrino medio": "Average order value",
  "Scorte aggiornate in tempo reale": "Real-time stock updates",
  "Scorte: {n}": "Stock: {n}",
  "Scritte solo da clienti che hanno acquistato il prodotto. Nascondi quelle non appropriate: la media si aggiorna da sola.": "Written only by customers who bought the product. Hide inappropriate ones: the average updates automatically.",
  "Scrivi una breve descrizione del Club.": "Write a short description of the Club.",
  "Scudo (resistente, sicuro)": "Shield (durable, safe)",
  "Se chiudi le iscrizioni, il Club sparisce dal negozio per chi non è membro. I membri attuali restano iscritti e possono uscire quando vogliono.": "If you close sign-ups, the Club disappears from the shop for non-members. Current members stay enrolled and can leave whenever they like.",
  "Se l’indirizzo è registrato riceverai un link per impostare la password.": "If the address is registered, you'll receive a link to set your password.",
  "Segna come completato": "Mark as completed",
  "Segna come pronto": "Mark as ready",
  "Segna come spedito": "Mark as shipped",
  "Segnala mancante": "Report missing",
  "Segnalato: {name}. Un responsabile vedrà la nota nell'ordine {number}.": "Reported: {name}. A manager will see the note on order {number}.",
  "Seleziona {n}": "Select {n}",
  "Seleziona il negozio per il personale di negozio.": "Select the store for store staff.",
  "Seleziona tutti": "Select all",
  "Senza commento": "No comment",
  "senza scadenza": "no expiry",
  "Serve per calcolare la spedizione": "Used to calculate shipping",
  "Sezioni": "Sections",
  "Sì": "Yes",
  "Simulatore": "Simulator",
  "Sistema": "System",
  "SKU {sku}": "SKU {sku}",
  "SKU / codice articolo *": "SKU / item code *",
  "SKU / EAN": "SKU / EAN",
  "SKU duplicato nel file": "Duplicate SKU in file",
  "SKU già esistente.": "SKU already exists.",
  "SKU mancante o non valido (lettere, numeri, . _ -)": "Missing or invalid SKU (letters, numbers, . _ -)",
  "Slug": "Slug",
  "Slug già esistente.": "Slug already exists.",
  "Soglia salvata.": "Threshold saved.",
  "Soglia scorte basse": "Low stock threshold",
  "Soglia scorte basse (pezzi)": "Low stock threshold (pieces)",
  "Sole (luce, estate)": "Sun (light, summer)",
  "Solo Club": "Club only",
  "Solo con consenso marketing": "Marketing consent only",
  "Solo per i membri del Casa & Te Club (mostrato nella pagina Club dell'app)": "Only for Casa & Te Club members (shown on the Club page of the app)",
  "Solo scorte basse (≤ {n})": "Low stock only (≤ {n})",
  "Spedisce": "Ships",
  "Spedisce ordini": "Ships orders",
  "Spediti": "Shipped",
  "Spedito": "Shipped",
  "Spedizione": "Shipping",
  "Spedizione gratis": "Free shipping",
  "Spedizione gratuita": "Free shipping",
  "Spedizione:": "Shipping:",
  "Spedizioni e ritiro": "Shipping & pickup",
  "Spesa massima": "Max spend",
  "Spesa minima": "Min spend",
  "Spesa minima prodotti (€)": "Min product spend (€)",
  "Spunta ogni prodotto per completare. Se un prodotto manca, usa \"Segnala mancante\": un responsabile farà il rimborso parziale.": "Tick each product to complete. If a product is missing, use \"Report missing\": a manager will issue a partial refund.",
  "Stampa distinta": "Print packing slip",
  "Stato": "Status",
  "Stato ordini": "Order status",
  "Stella (scelta, novità)": "Star (top pick, new)",
  "Stesso nome su tutti i prodotti del gruppo": "Same name on all products in the group",
  "Stock totale": "Total stock",
  "Stripe non raggiungibile o non configurato.": "Stripe unreachable or not configured.",
  "Successiva": "Next",
  "sul periodo precedente": "vs previous period",
  "Tariffa di spedizione": "Shipping rate",
  "Tariffa oltre 10 kg (provvisoria)": "Rate above 10 kg (provisional)",
  "Tariffa provvisoria": "Provisional rate",
  "Tariffe di spedizione": "Shipping rates",
  "Tariffe spedizione": "Shipping rates",
  "Tel.": "Tel.",
  "Telefono": "Phone",
  "Testo {n}": "Text {n}",
  "Tipo": "Type",
  "Titolo": "Title",
  "Togli da «In evidenza»": "Remove from featured",
  "Torna all'ordine": "Back to order",
  "Totale": "Total",
  "Totale ordini": "Total orders",
  "Tutte le azioni": "All actions",
  "Tutte le categorie": "All categories",
  "Tutte le consegne": "All delivery methods",
  "Tutti": "All",
  "Tutti (esclusi non pagati)": "All (excluding unpaid)",
  "Tutti gli ordini": "All orders",
  "Tutti gli stati": "All statuses",
  "Tutti i clienti": "All customers",
  "Tutti i negozi": "All stores",
  "Tutti i prodotti": "All products",
  "Tutti i tipi": "All types",
  "Tutto evaso": "All fulfilled",
  "Tutto pronto": "All ready",
  "Tutto salvato.": "All saved.",
  "Ultima modifica: {date}": "Last modified: {date}",
  "Ultimi 30 giorni": "Last 30 days",
  "Ultimi 7 giorni": "Last 7 days",
  "Ultimi 90 giorni": "Last 90 days",
  "Ultimo rimborso:": "Last refund:",
  "Un pezzo in meno di {name}": "One fewer {name}",
  "Un pezzo in più di {name}": "One more {name}",
  "Un prodotto è «sotto scorta» quando in un negozio ne restano al massimo questi pezzi. Usata in Panoramica (Avviso scorte) e in Gestione inventario (Solo scorte basse).": "A product is «low stock» when a store has this many pieces or fewer left. Used in Overview (Stock alert) and Inventory (Low stock only).",
  "Unità": "Unit",
  "Usato dal filtro Colore": "Used by the Colour filter",
  "Utente": "User",
  "Utente già esistente.": "User already exists.",
  "Utilizzi": "Uses",
  "Utilizzi dei codici Club": "Club code uses",
  "Utilizzi massimi": "Max uses",
  "Utilizzi massimi totali": "Max total uses",
  "Utilizzi per cliente": "Uses per customer",
  "Vai al contenuto": "Skip to content",
  "Vai alla preparazione": "Go to picking",
  "Vale solo per te: ogni membro del personale sceglie la propria lingua. Il negozio online resta in italiano.": "Applies only to you: each staff member chooses their own language. The online shop stays in Italian.",
  "Validità": "Validity",
  "Valido dal": "Valid from",
  "Valido fino al": "Valid until",
  "Valore": "Value",
  "Valore da (€, incluso)": "Value from (€, inclusive)",
  "Valore fino a (€, incluso)": "Value up to (€, inclusive)",
  "Valore prodotti": "Products value",
  "Valore prodotti (€)": "Products value (€)",
  "Valori non validi: controlla i campi.": "Invalid values: check the fields.",
  "Valutazione": "Rating",
  "Vanno bene anche i CSV con le stesse intestazioni.": "CSV files with the same headers work too.",
  "Variante": "Variant",
  "variante {label}": "variant {label}",
  "Varianti": "Variants",
  "Variazione": "Change",
  "Vendite degli ultimi 7 giorni": "Sales in the last 7 days",
  "Vendite di oggi": "Today's sales",
  "Venduti {n}": "{n} sold",
  "Verifica {i}/{n}…": "Checking {i}/{n}…",
  "Visibile": "Visible",
  "Visibile ai clienti": "Visible to customers",
  "Visibile ai membri del Club nella pagina delle offerte": "Visible to Club members on the offers page",
  "Visibile al cliente": "Visible to customer",
  "Visibilità": "Visibility",
  "Visualizza": "View",
  "Visualizza tutti gli ordini": "View all orders",
  "Visualizza tutto": "View all",
  "Vuoto = nessun limite": "Empty = no limit",
  "I primi {n} sono quelli visibili in home.": "The first {n} are the ones shown on the home page.",
  "In cima": "To top",
  "In offerta": "On offer",
  "Nessun prodotto in evidenza: aggiungi la stella ai prodotti in Gestione prodotti.": "No featured products: star products in Product management.",
  "Nessun prodotto in offerta: imposta un prezzo barrato nella scheda del prodotto.": "No products on offer: set a crossed-out price on the product page.",
  "Ordine salvato.": "Order saved.",
  "Prodotti con la stella in Gestione prodotti. Trascina le righe o usa le frecce, poi salva.": "Products starred in Product management. Drag the rows or use the arrows, then save.",
  "Prodotti con un prezzo barrato più alto del prezzo. Trascina le righe o usa le frecce, poi salva.": "Products with a crossed-out price higher than the price. Drag the rows or use the arrows, then save.",
  "Salva ordine": "Save order",
  "Scegli l'ordine dei prodotti nelle righe «In evidenza» e «In offerta» della home del negozio online.": "Choose the order of the products in the “In evidenza” and “In offerta” rows of the online shop home page.",
  "Sposta giù": "Move down",
  "Sposta su": "Move up",
  "Torna all’ordine alfabetico": "Back to alphabetical order",
  "Torna all’ordine per sconto": "Back to order by discount",
  "Vetrina home": "Home showcase",
  "in home": "on home",
  "Bozza": "Draft",
  "Programmato": "Scheduled",
  "Scaduto": "Expired",
  "Visibile nel negozio": "Live in the shop",
  "Volantino": "Flyer",
  "Il volantino del mese nell’app e nel negozio online: carica le pagine come immagini e/o il PDF da scaricare. I clienti vedono solo quelli pubblicati e nel periodo di validità.": "The monthly flyer in the app and the online shop: upload the pages as images and/or a downloadable PDF. Customers only see published flyers within their validity period.",
  "+ Nuovo volantino": "+ New flyer",
  "Nessun volantino. Creane uno con «+ Nuovo volantino».": "No flyers yet. Create one with “+ New flyer”.",
  "Contenuto": "Content",
  "{n} pagine": "{n} pages",
  "Apri PDF": "Open PDF",
  "Modifica volantino": "Edit flyer",
  "Nuovo volantino": "New flyer",
  "es. Volantino di ottobre": "e.g. October flyer",
  "La fine è prima dell’inizio.": "The end is before the start.",
  "Pubblicato (visibile ai clienti nel periodo di validità)": "Published (visible to customers during the validity period)",
  "Pagine (immagini, nell’ordine di lettura)": "Pages (images, in reading order)",
  "Aggiungi pagine": "Add pages",
  "JPG, PNG o WEBP, in verticale (es. 1200×1700 px). Puoi selezionare più file insieme: vengono ordinati per nome.": "JPG, PNG or WEBP, portrait (e.g. 1200×1700 px). You can select several files at once: they are sorted by name.",
  "PDF da scaricare (facoltativo)": "Downloadable PDF (optional)",
  "Nessun PDF": "No PDF",
  "Sostituisci PDF": "Replace PDF",
  "Carica PDF": "Upload PDF",
  "Aggiungi almeno le pagine o il PDF.": "Add at least the pages or the PDF.",
  "Il file deve essere un PDF.": "The file must be a PDF.",
  "PDF troppo grande (max 25 MB).": "PDF too large (max 25 MB).",
  "Immagine troppo grande (max 8 MB).": "Image too large (max 8 MB).",
  "Al massimo 40 pagine.": "40 pages at most.",
  "Eliminare il volantino \"{name}\"?": "Delete the flyer \"{name}\"?",
  "— Seleziona —": "— Select —",
  "+ Nuova azienda": "+ New company",
  "Alcuni negozi attivi non sono collegati a un’azienda: collegali in Negozi.": "Some active stores are not linked to a company: link them in Stores.",
  "Alcuni negozi attivi non sono collegati a un’azienda: i loro ordini usano i dati del gestore.": "Some active stores are not linked to a company: their orders use the operator's details.",
  "Azienda": "Company",
  "Azienda (venditore degli ordini di questo negozio)": "Company (seller of this store's orders)",
  "Aziende": "Companies",
  "CAP non valido (5 cifre).": "Invalid postcode (5 digits).",
  "Capitale sociale non valido.": "Invalid share capital.",
  "Capitale sociale versato (€)": "Paid-up share capital (€)",
  "Codice fiscale": "Tax code",
  "Codice fiscale non valido.": "Invalid tax code.",
  "Contatti": "Contacts",
  "Controlla gli indirizzi email.": "Check the email addresses.",
  "Copia i dati dalla visura camerale. Le modifiche valgono per i nuovi ordini; gli ordini già fatti conservano i dati del venditore di allora.": "Copy the details from the company registry extract (visura). Changes apply to new orders; existing orders keep the seller details they were placed with.",
  "Da collegare": "To link",
  "Dati legali mostrati nelle condizioni di vendita, nella privacy e negli ordini. Il gestore è chi pubblica l’app; il venditore di un ordine è l’azienda del negozio che lo prepara.": "Legal details shown in the terms of sale, the privacy notice and orders. The operator publishes the app; the seller of an order is the company of the store that prepares it.",
  "Eliminare l’azienda \"{name}\"?": "Delete the company \"{name}\"?",
  "Email assistenza clienti": "Customer support email",
  "Email privacy": "Privacy email",
  "Esiste già un gestore della piattaforma.": "A platform operator already exists.",
  "Gestore": "Operator",
  "gestore": "operator",
  "Gestore della piattaforma (chi pubblica l’app e il sito)": "Platform operator (publishes the app and the website)",
  "Indica quale azienda gestisce la piattaforma (gestore).": "Set which company runs the platform (operator).",
  "Le aziende si gestiscono in Negozi → Aziende": "Companies are managed in Stores → Companies",
  "Lo scontrino o la fattura vanno emessi da questa azienda.": "The receipt or invoice must be issued by this company.",
  "Modifica azienda": "Edit company",
  "Nessuna azienda. Aggiungi il gestore e le aziende dei negozi.": "No companies. Add the operator and the stores' companies.",
  "Numero REA": "REA number",
  "Nuova azienda": "New company",
  "Partita IVA": "VAT number",
  "Partita IVA non valida (11 cifre).": "Invalid VAT number (11 digits).",
  "Per le richieste sui dati personali; se vuota si usa l’email assistenza": "For personal-data requests; if empty, the support email is used",
  "Prima scollega i negozi da questa azienda.": "First unlink the stores from this company.",
  "Provincia non valida (2 lettere, es. LU).": "Invalid province (2 letters, e.g. LU).",
  "Questa partita IVA è già registrata.": "This VAT number is already registered.",
  "Ragione sociale": "Company name",
  "Ragione sociale, indirizzo e città sono obbligatori.": "Company name, address and city are required.",
  "Se uguale alla partita IVA puoi lasciarlo vuoto": "Leave empty if it equals the VAT number",
  "Sede legale (via e numero)": "Registered office (street and number)",
  "Un negozio attivo deve essere collegato all’azienda che vende i suoi ordini.": "An active store must be linked to the company that sells its orders.",
  "Venditore": "Seller",
  "Annulla registrazione": "Undo registration",
  "Batti l’ordine sul registratore di cassa del negozio, poi segnalo qui. Fino ad allora la merce resta esclusa dalla disponibilità online.": "Ring the order up on the store's till, then mark it here. Until then the goods stay out of the online stock.",
  "Cassa": "Till",
  "Cassa: tutti": "Till: all",
  "Da registrare in cassa": "To ring up at the till",
  "Ordine registrato in cassa": "Order rung up at the till",
  "Prezzo, promozioni e giacenze arrivano dal gestionale (codice {code}): le modifiche a prezzo qui vengono sovrascritte alla prossima sincronizzazione. Nome, descrizione, categoria e foto restano quelli impostati qui.": "Price, promotions and stock come from the ERP (code {code}): price changes made here are overwritten at the next sync. Name, description, category and photos stay as set here.",
  "Registrati in cassa": "Rung up at the till",
  "Registrato in cassa": "Rung up at the till",
  "Registrato in cassa il {date}. Il gestionale scalerà la merce alla prossima sincronizzazione.": "Rung up at the till on {date}. The ERP will deduct the goods at the next sync.",
  "Registrazione in cassa annullata": "Till registration undone",
  "Segna come registrato in cassa": "Mark as rung up at the till",
  "Peso in grammi": "Weight in grams",
  "Peso in grammi non valido.": "Invalid weight in grams.",
  "Senza peso": "No weight",
  "Senza peso il prodotto si può solo ritirare in negozio": "Without a weight the product can only be collected in store",
  "Resi e assistenza": "Returns & after-sales",
  "Le richieste dei clienti dalla pagina dell’ordine. Il responsabile approva e rimborsa; il negozio registra la consegna degli articoli.": "Customer requests from the order page. A manager approves and refunds; the store records when the items are brought in.",
  "Da gestire": "To handle",
  "Da valutare": "To review",
  "Attesi in negozio": "Expected in store",
  "Da rimborsare o cambiare": "To refund or exchange",
  "Chiusi": "Closed",
  "Codice reso (RESO-…)": "Return code (RESO-…)",
  "Cerca per codice reso": "Search by return code",
  "Nessuna richiesta.": "No requests.",
  "Reso": "Return",
  "Motivo": "Reason",
  "Richiesta": "Request",
  "Cambio": "Exchange",
  "Rimborso": "Refund",
  "In valutazione": "Under review",
  "Approvato": "Approved",
  "Non accettato": "Not accepted",
  "Articoli ricevuti in negozio": "Items received in store",
  "Cambio completato": "Exchange completed",
  "Ho cambiato idea": "Changed my mind",
  "Difettoso o danneggiato": "Faulty or damaged",
  "Articolo sbagliato": "Wrong item",
  "Articolo mancante": "Missing item",
  "Sul metodo di pagamento": "To the payment method",
  "Buono CASA & TE": "CASA & TE voucher",
  "Cambio con lo stesso prodotto": "Exchange for the same product",
  "Foto del cliente": "Customer photo",
  "Nota della decisione": "Decision note",
  "Buono emesso": "Voucher issued",
  "Rimborsato sulla carta": "Refunded to the card",
  "Nota per il cliente": "Note for the customer",
  "Obbligatoria se rifiuti: il cliente la riceve via email.": "Required when rejecting: the customer receives it by email.",
  "{n} approvato: il cliente porterà gli articoli in negozio.": "{n} approved: the customer will bring the items to the store.",
  "Approva": "Approve",
  "{n} rifiutato.": "{n} rejected.",
  "Rifiuta": "Reject",
  "In attesa dell’approvazione di un responsabile.": "Waiting for a manager's approval.",
  "Controlla gli articoli quando il cliente li porta in negozio, poi registra la consegna.": "Check the items when the customer brings them in, then record it.",
  "Articoli del reso {n} ricevuti.": "Items of return {n} received.",
  "Cambio {n} completato.": "Exchange {n} completed.",
  "Prodotto sostitutivo consegnato": "Replacement handed over",
  "Importo da rimborsare (€)": "Amount to refund (€)",
  "Al massimo {max}: il valore pagato per gli articoli resi.": "At most {max}: the price paid for the returned items.",
  "Rimborso di {amount} emesso sulla carta.": "Refund of {amount} issued to the card.",
  "Rimborsa sulla carta": "Refund to the card",
  "Buono di {amount} emesso: il cliente riceve il codice via email.": "Voucher of {amount} issued: the customer receives the code by email.",
  "Emetti buono": "Issue voucher",
  "Il cliente ha scelto: {m}.": "The customer chose: {m}.",
  "Il rimborso lo emette un responsabile.": "A manager issues the refund.",
  "Operazione non possibile nello stato attuale del reso.": "Not possible in the current state of the return.",
  "Reso non trovato.": "Return not found.",
  "Scrivi il motivo del rifiuto.": "Write the reason for the rejection.",
  "Nota per i clienti (facoltativa)": "Note for customers (optional)",
  "Es. per chi valgono le offerte. Max 300 caratteri.": "E.g. who the offers are for. Max 300 characters.",
  "Titolo pagina": "Page title",
  "Titolo della pagina {n}": "Title of page {n}",
};
export default dict;
